import type { Components, Theme } from '@mui/material/styles';
import { createTheme as createMuiTheme } from '@mui/material/styles';

import type { SettingsState } from '../components/settings/types';
import { components } from './core/components';
import { customShadows } from './core/customShadows';
import * as mixins from './core/mixins/mixins';
import { palette } from './core/palette';
import { shadows } from './core/shadows';
import { typography } from './core/typography';
import { themeConfig } from './themeConfig';
import type { ThemeOptions } from './types';

export const baseTheme: ThemeOptions = {
  colorSchemes: {
    light: {
      palette: palette.light,
      shadows: shadows.light,
      customShadows: customShadows.light,
    },
    dark: {
      palette: palette.dark,
      shadows: shadows.dark,
      customShadows: customShadows.dark,
    },
  },
  mixins: mixins.mixins,
  components,
  typography,
  shape: { borderRadius: 8 },
  direction: themeConfig.direction,
  cssVariables: themeConfig.cssVariables,
  defaultColorScheme: themeConfig.defaultMode,
};

// ----------------------------------------------------------------------

type CreateThemeProps = {
  settingsState?: SettingsState;
  themeOverrides?: ThemeOptions;
  localeComponents?: { components?: Components<Theme> };
};

export function createTheme({ settingsState, themeOverrides = {} }: CreateThemeProps = {}): Theme {
  const settingsBasedOverrides: ThemeOptions = {
    ...(settingsState?.colorScheme ? { defaultColorScheme: settingsState.colorScheme } : {}),
  } as ThemeOptions;

  // Create and return the final theme
  const theme = createMuiTheme(baseTheme, settingsBasedOverrides, themeOverrides);

  return theme;
}
